import controller from './templates.controller';
import template from './templates.view.html';

let TemplatesComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default TemplatesComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/templates/templates.component.js
 **/